module.exports = __webpack_public_path__ + "img/bg3.e46e0d72.png";